import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// import { RegisterContent } from 'src/app/models/master';

import { AppConstants } from "../../../app_setting/app-constants";

@Component({
  selector: 'app-register-information-dialog',
  templateUrl: './register-information-dialog.component.html',
  styleUrls: ['./register-information-dialog.component.css']
})
export class RegisterInformationDialogComponent implements OnInit {
  @Input() content: any;

  appConstants = AppConstants

  constructor(public activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit() {
  }

  goToHome() {
    this.activeModal.close();
    this.router.navigate(['/home']);
  }

}
